export const ResourcePages = {
  COLLEGE: 'College',
  LIFE_READINESS: 'Life Readiness',
  EMPLOYER: 'Employer',
} as const;

export type ResourcePagesType = (typeof ResourcePages)[keyof typeof ResourcePages];
